import { combine } from '../combine'
import type { Factory } from '../factory'
import type { Transformer } from '../transformer'

/**
 * AWSTimestamp's are represented in seconds, so this converts seconds to
 * milliseconds, which are expected by the Date object.
 */
const TIMESTAMP_TO_DATE_FACTOR = 1000

type AwsScalarTransformer<
  TEntityOutputType extends string,
  TGraphqlOutputType extends string,
  TEntity extends NonNullable<unknown>,
  TGraphql extends NonNullable<unknown>,
> = Transformer<TEntityOutputType, TGraphql | Nullish, TEntity | undefined> &
  Transformer<TGraphqlOutputType, TEntity | Nullish, TGraphql | Nullish>

/**
 * TODO:
 */
export class AwsScalarTransformers<
  TEntityOutputType extends string,
  TGraphqlOutputType extends string,
> {
  /**
   * TODO: link
   */
  public readonly date: AwsScalarTransformer<
    TEntityOutputType,
    TGraphqlOutputType,
    Date,
    string
  >
  /**
   * TODO: link
   */
  public readonly datetime: AwsScalarTransformer<
    TEntityOutputType,
    TGraphqlOutputType,
    Date,
    string
  >
  /**
   * TODO: link
   */
  public readonly time: AwsScalarTransformer<
    TEntityOutputType,
    TGraphqlOutputType,
    Date,
    string
  >
  /**
   * TODO: link
   */
  public readonly timestamp: AwsScalarTransformer<
    TEntityOutputType,
    TGraphqlOutputType,
    Date,
    number
  >

  constructor({
    factories,
  }: AwsScalarTransformers.constructor.Params<
    TEntityOutputType,
    TGraphqlOutputType
  >) {
    this.date = combine(
      factories.graphqlToEntity.custom((dateStr: string | Nullish) =>
        typeof dateStr === 'string' ? new Date(dateStr) : undefined,
      ),
      factories.entityToGraphql.custom(
        (date: Date | Nullish) =>
          date && `${date.toISOString().split('T')[0]}Z`,
      ),
    )

    this.datetime = combine(
      factories.graphqlToEntity.custom((dateTimeStr: string | Nullish) =>
        typeof dateTimeStr === 'string' ? new Date(dateTimeStr) : undefined,
      ),
      factories.entityToGraphql.custom((dateTime: Date | Nullish) =>
        dateTime?.toISOString(),
      ),
    )

    this.time = combine(
      factories.graphqlToEntity.custom((timeStr: string | Nullish) =>
        typeof timeStr === 'string' ? new Date(timeStr) : undefined,
      ),
      factories.entityToGraphql.custom(
        (time: Date | Nullish) => time?.toISOString().split('T')[1],
      ),
    )

    this.timestamp = combine(
      factories.graphqlToEntity.custom((timestampNum: number | Nullish) =>
        typeof timestampNum === 'number'
          ? new Date(timestampNum * TIMESTAMP_TO_DATE_FACTOR)
          : undefined,
      ),
      factories.entityToGraphql.custom(
        (timestamp: Date | Nullish) =>
          timestamp &&
          Math.round(timestamp.valueOf() / TIMESTAMP_TO_DATE_FACTOR),
      ),
    )
  }
}
export namespace AwsScalarTransformers {
  export namespace constructor {
    export interface Params<
      TEntityOutputType extends string,
      TGraphqlOutputType extends string,
    > {
      readonly factories: {
        readonly graphqlToEntity: Factory<TEntityOutputType>
        readonly entityToGraphql: Factory<TGraphqlOutputType>
      }
    }
  }
}
